import { useEffect, useState } from 'react';

import { Pane } from '../types';

export const useInkBar = ({ refWrapper, dropdownPanes, activeKey, wrapperWidth }: Props) => {
  const [styles, setStyles] = useState({ width: 0, left: 0 });

  useEffect(() => {
    if (!refWrapper.current) return;

    const isActiveMoreItem = dropdownPanes?.some(pane => pane.key === activeKey);
    const activeTab = refWrapper.current.querySelector(
      isActiveMoreItem ? '[data-name="more"]' : '[data-tab-active="true"]',
    ) as HTMLDivElement;

    if (!activeTab) return;

    setStyles({
      width: activeTab.offsetWidth,
      left: activeTab.offsetLeft,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, wrapperWidth, dropdownPanes]);

  return styles;
};

type Props = {
  refWrapper: React.RefObject<HTMLDivElement>;
  wrapperWidth: number;
  dropdownPanes: Pane[];
  activeKey: string;
};
